import { Link } from "react-router-dom";
import classNames from "classnames/bind";
import styles from "../styles/Home.module.css";
import PerformanceSlider from "../components/PerformanceSlider";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/autoplay";
import skyscraper1 from "../assets/img/skyscraper1.jpg";
import skyscraper2 from "../assets/img/skyscraper2.jpg";
import NaverMap from "../components/NaverMap";
import { useState } from "react";
import BusinessFieldSlider from "../components/BusinessFieldSlider";

const cx = classNames.bind(styles);

export default function Home() {
  const locations = [
    {
      name: "서울 본사",
      lat: 37.559453,
      lng: 126.833913,
      scale: 17,
      address: "서울시 강서구 공항대로 237 에이스타워마곡 1306호",
    },
    {
      name: "경기 지점",
      lat: 37.21077,
      lng: 127.100293,
      scale: 17,
      address: "경기도 화성시 동탄대로 636-3 메가비즈타워 C동 302호",
    },
  ];

  const [selected, setSelected] = useState(locations[0]);

  return (
    <>
      <div className={cx("visual")}>
        <div className={cx("visualTextContainer")}>
          <div className={cx("visualTextWrap")}>
            <div className={cx("visualText", "reveal")}>
              <span>BESTCLAIMS SURVEY & LOSS ADJUSTER</span>
              <h3>
                정확한 판단, 신속한 대응, 신뢰할 수 있는 손해사정
                <br />
                <strong>
                  모든 부분에서 <span className={cx("name")}>으뜸손해사정</span>
                  이 함께합니다.
                </strong>
              </h3>
              <Link to="/profile">더보기 →</Link>
            </div>
          </div>
        </div>
        <Swiper
          className={cx("visualSwiper")}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            disableOnTouch: false,
          }}
          loop={true}
          modules={[Autoplay]}
        >
          <SwiperSlide className={cx("visualImg")}>
            <img src={skyscraper1} alt="visual" />
          </SwiperSlide>
          <SwiperSlide className={cx("visualImg")}>
            <img src={skyscraper2} alt="visual" />
          </SwiperSlide>
        </Swiper>
        <div className={cx("bg")}></div>
      </div>

      <div className={cx("section", "info", "reveal")}>
        <div className={cx("sectionTop")}>
          <div className={cx("sectionTitle")}>사업 분야 소개</div>
          <Link to="/performance/disasters" className={cx("sectionMore")}>
            더보기 →
          </Link>
        </div>
        <BusinessFieldSlider />
      </div>
      <div className={cx("sectionWrap", "performance")}>
        <div className={cx("section", "reveal")}>
          <div className={cx("sectionTop")}>
            <div className={cx("sectionTitle")}>업무 수행 실적</div>
            <Link to="/performance/portfolio" className={cx("sectionMore")}>
              더보기 →
            </Link>
          </div>
          <PerformanceSlider />
        </div>
      </div>
      {/* map */}
      <div className={cx("locationSection", "reveal")}>
        <div className={cx("mapSection")}>
          <div className={cx("map")}>
            <NaverMap location={selected} />
          </div>
        </div>

        <div className={cx("infoSection")}>
          <div className={cx("leftBox")}>
            <div className={cx("locBtn")}>
              {locations.map((loc) => (
                <div
                  key={loc.name}
                  onClick={() => setSelected(loc)}
                  className={cx({ active: selected.name === loc.name })}
                >
                  {loc.name}
                </div>
              ))}
            </div>
          </div>

          <div className={cx("rightBox")}>
            <div className={cx("locationInfo")}>
              으뜸손해사정은 고객과의 원활한 상담과 신속한 업무 협의를 위해
              접근성이 좋은 위치에서 운영됩니다.
              <br />
              방문 상담을 원하시는 경우 사전 예약을 통해 보다 자세하고 편안한
              안내를 받으실 수 있습니다.
              <div className={cx("address")}>{selected.address}</div>
              <Link to="/profile/map" className={cx("routeLink")}>
                오시는길 →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
